module.exports = __webpack_public_path__ + "img/logo-imprimax-mini.682cbeb7.svg";